import { effect, inject, Injector, untracked } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import type { CanActivateFn } from '@angular/router';
import { LocalStorageService } from '@capturum/ui/api';
import { PermissionService } from '@shared/services/permission.service';
import { TenantRefService } from '@shared/services/tenant-ref.service';
import { BehaviorSubject, map } from 'rxjs';

export const permissionsGuard: CanActivateFn = (route, state) => {
  const permissions = new BehaviorSubject<boolean>(false);
  const permissionService = inject(PermissionService);
  const injector = inject(Injector);
  const tenantRefService = inject(TenantRefService);
  const localStorageService = inject(LocalStorageService);

  if (localStorageService.getItem('tenantRef')) {
    return permissionService.loadPermissions().pipe(
      map((permissions) => {
        return !!permissions;
      }),
    );
  }

  effect(
    () => {
      const tenantRef = tenantRefService.selectedTenantRef();

      if (tenantRef) {
        untracked(() => {
          const userPermissions = toSignal(permissionService.loadPermissions(), {
            injector,
          });

          permissions.next(!!userPermissions());
        });
      }
    },
    {
      injector,
    },
  );

  return permissions.asObservable();
};
